import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const ParentContainer = styled("div", {
  name: "DraggableParentContainer",
})({
  display: "flex",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 0",
});

const MainSection = styled("div")({
  position: "relative",
  overflow: "hidden",
});

export const SideSection = styled(MainSection, {
  shouldForwardProp(propName) {
    return propName !== "border";
  },
  name: "SideSection",
})<{ border?: "left" | "right" }>(({ border }) => ({
  position: "relative",
  maxWidth: "310px",
  width: "100%",
  overflow: "auto",
  overflowX: "hidden",
  borderRightWidth: border === "right" ? "1px" : undefined,
  borderRightStyle: border === "right" ? "solid" : undefined,
  borderRightColor: border === "right" ? colors.gray200 : undefined,

  borderLeftWidth: border === "left" ? "1px" : undefined,
  borderLeftStyle: border === "left" ? "solid" : undefined,
  borderLeftColor: border === "left" ? colors.gray200 : undefined,

  backgroundColor: colors.white,
  scrollbarGutter: "stable",

  "&::-webkit-scrollbar": {
    width: "2.6px",
    borderBottomRightRadius: "8px",
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "white",
    borderBottomRightRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: colors.gray500,
    borderBottomRightRadius: "8px",
  },
}));

export const CenterSection = styled(MainSection)({
  flex: 1,
  overflowY: "auto",
  padding: "12px 16px 16px 16px",
  "&::-webkit-scrollbar": {
    width: "4px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: colors.gray500,
    borderRadius: "8px",
  },
});

export const HideButton = styled(MainSection)({
  position: "absolute",
  top: 0,
  right: "-16px",
});
